export const _LOAD_MODEL_ = 'Load:HuntingWords';

export const CELL_SIZE = 40;

export const CELL = {
  text: null,
  positionx: 0,
  positiony: 0,
};

const horizontalConfig = {
  getWidth: (size, length) => length * size,
  getHeight: size => size,
  transform: 'none',
  origin: 'top left',
  transformAngle: null,
  adjustCol: false,
  adjustX: 0,
  adjustY: 4,
  adjustPrintX: 0,
  adjustPrintY: 0,
};
const verticalConfig = {
  getWidth: size => size,
  getHeight: (size, length) => length * size,
  transform: 'none',
  origin: 'top left',
  transformAngle: null,
  adjustCol: false,
  adjustX: 0,
  adjustY: 0,
  adjustPrintX: 0,
  adjustPrintY: 0,
};

export const DIRECTION_CONFIG = {
  horizontal: { ...horizontalConfig },
  invertedHorizontal: { ...horizontalConfig },
  vertical: { ...verticalConfig },
  invertedVertical: { ...verticalConfig },
  'down-right': {
    getWidth: (size, length) => length * size * Math.SQRT2,
    getHeight: size => size,
    transform: 'translateY(-50%) rotate(45deg)',
    origin: 'left center',
    transformAngle: 45,
    adjustX: 10,
    adjustY: -14,
    adjustPrintX: 10,
    adjustPrintY: -10,
    adjustCol: false,
  },
  'down-left': {
    getWidth: (size, length) => length * size * Math.SQRT2,
    getHeight: size => size,
    transform: 'translateY(-50%) rotate(135deg)',
    origin: 'left center',
    transformAngle: 135,
    adjustX: 18,
    adjustY: 15,
    adjustPrintX: 10,
    adjustPrintY: 10,
    adjustCol: true,
  },
  'up-left': {
    getWidth: (size, length) => length * size * Math.SQRT2,
    getHeight: size => size,
    transform: 'translateY(50%) rotate(-135deg)',
    origin: 'left center',
    transformAngle: -135,
    adjustX: 25,
    adjustY: 18,
    adjustPrintX: 18,
    adjustPrintY: 10,
    adjustCol: true,
  },
  'up-right': {
    getWidth: (size, length) => length * size * Math.SQRT2,
    getHeight: size => size,
    transform: 'translateY(50%) rotate(-45deg)',
    origin: 'left center',
    transformAngle: -45,
    adjustLeft: false,
    adjustX: -10,
    adjustY: 26,
    adjustPrintX: -10,
    adjustPrintY: 18,
    adjustCol: false,
  },
};


export const LABELS_POSITIONS = {
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  diagonal: 'Diagonal',
  inverted: 'Invertida',
  invertedHorizontal: 'Horizontal Invertida',
  invertedVertical: 'Vertical Invertida',
  invertedDiagonal: 'Diagonal Invertida',
};

export const DEFAULT_SETTINGS = {
  wordsList: [],
  placedWords: [],
  words: '',
  positions: {
    horizontal: true,
    vertical: true,
    diagonal: false,
  },
  invertedPositions: {
    invertedHorizontal: false,
    invertedVertical: false,
    invertedDiagonal: false,
  },
  percentages: {
    horizontal: 0,
    vertical: 0,
    diagonal: 0,
    invertedHorizontal: 0,
    invertedVertical: 0,
    invertedDiagonal: 0,
  },
  enableSubWord: false,
  enablePercentageDistribution: false,
  enableGroupedGeneration: false,
  showGrid: false,
  showWordPositions: true,
  highlightMode: 'border',
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 3,
  rows: 15,
  columns: 15,
  settings: { ...DEFAULT_SETTINGS },
  created_at: new Date(),
  updated_at: new Date(),
  table: [],
  children: [],
};
